<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell>

  @if (refurbishment) {
    <app-page-detail-hero [auditStamp]="refurbishment"
      icon="pi pi-wrench"
      [eyebrow]="'Refurbishment #' + refurbishment.id"
      [title]="itemName(refurbishment.itemId)"
      [subtitle]="(refurbishment.sourceType || '-') + ' | ' + supplierName(refurbishment)">
      <div tags>
        <p-tag [value]="refurbishment.status" [severity]="statusSeverity(refurbishment.status)"></p-tag>
        <p-tag [value]="refurbishment.sourceType" severity="secondary"></p-tag>
      </div>
      <div actions>
        <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/warehousing/refurbishment"></p-button>
        <p-button label="Create" icon="pi pi-plus" severity="warn" routerLink="/warehousing/refurbishment/add"></p-button>
      </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <div class="warehousing-detail-grid">
      <app-page-form-section icon="pi pi-box" title="Refurbishment Header" subtitle="Stock unit, item, supplier, and repair source.">
        <div class="warehousing-detail-list">
          <div><span>Stock Unit</span><strong>{{ refurbishment.stockUnitId }}</strong></div>
          <div><span>Item</span><strong>{{ itemName(refurbishment.itemId) }}</strong></div>
          <div><span>Source</span><strong>{{ refurbishment.sourceType }}</strong></div>
          <div><span>Supplier</span><strong>{{ supplierName(refurbishment) }}</strong></div>
          <div><span>Start Date</span><strong>{{ refurbishment.startDate || '-' }}</strong></div>
          <div><span>End Date</span><strong>{{ refurbishment.endDate || '-' }}</strong></div>
        </div>
      </app-page-form-section>

      <div class="warehousing-detail-stack">
        <app-page-form-section icon="pi pi-money-bill" title="Cost Summary" subtitle="Estimated and final refurbishment cost.">
          <div class="warehousing-detail-list">
            <div><span>Estimated Cost</span><strong>{{ refurbishment.estimatedCost || 0 | number:'1.2-2' }}</strong></div>
            <div><span>Actual Cost</span><strong>{{ refurbishment.actualCost || 0 | number:'1.2-2' }}</strong></div>
          </div>
        </app-page-form-section>

        <app-page-form-section icon="pi pi-align-left" title="Notes and Evidence" subtitle="Repair notes and uploaded evidence.">
          <div class="flex flex-column gap-3">
            <div class="surface-ground border-round p-3 line-height-3" [innerHTML]="refurbishment.notes || '<p>-</p>'"></div>

            @if (evidenceUrls(refurbishment).length) {
              <div class="grid">
                @for (url of evidenceUrls(refurbishment); track url) {
                  <div class="col-12 md:col-4">
                    <div class="border-1 surface-border border-round p-3 h-full flex flex-column gap-2">
                    @if (isImageUrl(url)) {
                      <p-image [src]="url" [alt]="evidenceFileName(url)" [preview]="true" width="180"></p-image>
                    } @else {
                      <a [href]="url" target="_blank" rel="noopener noreferrer">{{ evidenceFileName(url) }}</a>
                    }
                    </div>
                  </div>
                }
              </div>
            } @else {
              <span class="cell-meta">No evidence uploaded.</span>
            }
          </div>
        </app-page-form-section>
      </div>
    </div>
  } @else if (!isLoading) {
    <div class="warehousing-empty-detail">
      <i class="pi pi-search"></i>
      <strong>Refurbishment record not found</strong>
      <span>The selected refurbishment record could not be loaded.</span>
    </div>
  }
</app-page-shell>
